import React from 'react';

import styled from 'styled-components/macro';
import times from 'lodash.times';
import ContentLoader from 'react-content-loader';

import { Relative } from '../../../PerformanceTrend/shared/PerformanceTrend.style';
import { TrendsWrapper } from '../AgeOverTime.styles';

export const LoaderWrapper = styled.div`
  margin: 1.5rem;
`;

const StyledContentLoader = styled(ContentLoader)`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 175px;
`;

const AgeTrendLoader: React.FC<any> = () => {
  return (
    <LoaderWrapper>
      <Relative>
        <TrendsWrapper isLoader>
          {times(5, (n) => (
            <StyledContentLoader
              key={`trend-skeleton-${n}`}
              viewBox={'0 0 300 150'}
            >
              <path d="M.6 74.7c2.4 1 5.2.4 7-1.7l3.6-3.9c2.8-3 6.5-4.5 10.2-4.2 3.8.3 7.4 1.6 10.7 3.7l1.8 1.2c3 1.9 6.2 3.4 9.6 4.3l.6.1c3.8 1 7.4 2.7 10.6 5.2l.8.6c2.8 2.1 6.5 1.5 8.7-1.5l2.9-3.9a18 18 0 0110-6.9c4-1 8 .5 10.8 3.8l2.3 2.7c3 3.6 6.3 6.8 10 9.5l.9.7a14 14 0 009.6 2.9 28 28 0 0010.3-3l.5-.2c3.7-1.9 8-1.4 11.3 1.3l1.5 1.2a8.4 8.4 0 009.5 1l.2-.2c3.7-2.2 8.1-1.8 11.5 1l1.3 1.2c2.8 2.3 6.2 3 9.5 1.9l3-1c1.7-.6 3.4-1 5.2-1.5l2.9-.8c3.4-.8 6.6-2.9 9-5.8l3.2-4c2.8-3.3 6-6.3 9.5-8.7l.7-.5A36 36 0 00209 60l6.3-9 1.4-2 6.3-9.7c2.6-3.9 7.2-5 10.9-2.6l.7.4c3 2 6.6 2.5 10 1.3 3.6-1.2 7-2.9 10.3-5.1l.8-.6c3.5-2.3 7.8-2.6 11.5-.7 3.8 1.8 6.8 5.2 8.6 9.5l4.5 10.5c1.2 3 4.2 4.1 6.7 2.7.6-.4 1.2-.9 1.6-1.5l1.8-2.4a33 33 0 019.3-8.7l.5-.3c3.6-2.2 7-4.7 10.3-7.6l5.7-5 1 1.6-5.7 5c-3 2.7-6.4 5.1-9.8 7.2l-.8.5c-3.5 2.1-6.7 5-9.3 8.5l-1.7 2.5a7 7 0 01-2.2 2c-3.3 1.8-7.3.2-9-3.6l-4.4-10.5a17 17 0 00-7.7-8.7 9.7 9.7 0 00-10 .7l-.9.6c-3.4 2.3-7 4-10.7 5.3-3.7 1.3-7.8.7-11.2-1.5l-.7-.4c-3-2-6.7-1-8.8 2l-6.3 9.7-1.4 2.1-6.3 9c-2.6 3.8-5.8 7-9.3 9.5l-.5.3a46.3 46.3 0 00-9.8 9l-3.2 3.8a18.9 18.9 0 01-9.8 6.4l-3 .8a73 73 0 00-5 1.5l-3 1c-3.8 1.2-7.8.4-11-2.3l-1.3-1.1a8.2 8.2 0 00-9.4-1l-.3.1a9.9 9.9 0 01-11.5-.9l-1.5-1.2a8.8 8.8 0 00-9.7-1.1l-.4.2a29.5 29.5 0 01-10.9 3.1c-3.7.3-7.5-.8-10.7-3.2l-.8-.7A65.1 65.1 0 0189 75.5l-2.3-2.7a9.1 9.1 0 00-9.2-3.2c-3.5.9-6.8 3-9.1 6.3l-3 4c-2.7 3.6-7.3 4.4-10.8 1.7l-.8-.6c-3-2.2-6.1-3.8-9.5-4.7l-.5-.2A36 36 0 0133 71.5l-1.8-1.2c-3-2-6.5-3.2-10-3.5-3.3-.2-6.5 1.1-9 3.7l-3.5 4a7.7 7.7 0 01-8.8 2l.6-1.8z" />
            </StyledContentLoader>
          ))}
        </TrendsWrapper>
      </Relative>
    </LoaderWrapper>
  );
};

export default AgeTrendLoader;
